/* eslint-disable */
import { isWechat, loadScript } from './index'
import { getWechatConfig } from '@/service'

export async function initWechatSDK () {
  await loadScript('//res.wx.qq.com/open/js/jweixin-1.2.0.js')
  const response = await getWechatConfig()
// inject for wechat
  if (isWechat()) {
    configWechat({
      wechatSign: response.data,
      share: {
        title: '凯迪克图书',
        content: '创立于2010年，是中国领先的亲子阅读推广及产品服务整体解决方案品牌商。',
        url: window.location.href,
        image: 'https://static.kdkts.com/dist/img/share.b251a338.jpg',
      },
    })
  }
}

window.wxConfigured = false

export function configWechat (data, share = true) {
  // 微信分享
  window.wxConfigured = true
  wx.config({
    debug: false,
    appId: data.wechatSign.appId,
    timestamp: data.wechatSign.timestamp,
    nonceStr: data.wechatSign.nonceStr,
    signature: data.wechatSign.signature,
    jsApiList: [
      'onMenuShareTimeline',
      'onMenuShareAppMessage',
      'onMenuShareQQ',
      'onMenuShareWeibo',
      'onMenuShareQZone',
      'chooseWXPay',

      // open photo browser
      'chooseImage',
      'getLocalImgData',
    ],
  })

  if (!share) return

  wx.ready(function () {
    // 在这里调用 API
    const shareTitle = data.share.title
    const shareDesc = data.share.content
    const shareLink = data.share.url
    const shareImg = data.share.image

    // 分享给朋友事件绑定
    wx.onMenuShareAppMessage({title: shareTitle, desc: shareDesc, link: shareLink, imgUrl: shareImg, success: () => { window.shareWechat && window.shareWechat() }})

    // 分享到朋友圈
    wx.onMenuShareTimeline({title: shareTitle, link: shareLink, imgUrl: shareImg, success: () => { window.shareWechat && window.shareWechat() }})

    // 分享到QQ
    wx.onMenuShareQQ({title: shareTitle, desc: shareDesc, link: shareLink, imgUrl: shareImg, success: () => { window.shareWechat && window.shareWechat() }})

    // 分享到微博
    wx.onMenuShareWeibo({title: shareTitle, desc: shareDesc, link: shareLink, imgUrl: shareImg, success: () => { window.shareWechat && window.shareWechat() }})

    // 分享到QQ空间
    wx.onMenuShareQZone({title: shareTitle, desc: shareDesc, link: shareLink, imgUrl: shareImg, success: () => { window.shareWechat && window.shareWechat() }})
  })
}
